// extracted by mini-css-extract-plugin
export default {"radioLabel":"WebStoreItemForm_radioLabel__i5TOt","switchLabel":"WebStoreItemForm_switchLabel__bWTij","textField":"WebStoreItemForm_textField__KJAxU"};